package medicine.containers

import react.*
import react.dom.div
import setTitle
import medicine.components.MedicineEdit

external interface MedicineEditPageProps : RProps {
    var id: String
}

val MedicineEditPageProvider = functionalComponent<MedicineEditPageProps> { props ->

    setTitle("中药编辑")

    useEffectOnce { }

    div("MedicineEditPage-page") {
        child(MedicineEdit) {
            attrs {
                id = props.id
            }
        }
    }
}
